import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { PartyPopper, ArrowRight } from "lucide-react";
import { useAuth, ROLE_THEMES } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import GTFLogo from "@/components/GTFLogo";

export default function Welcome() {
  const nav = useNavigate();
  const { user } = useAuth();
  const { t } = useI18n();
  const theme = user ? ROLE_THEMES[user.role] : ROLE_THEMES.farmer;

  useEffect(() => {
    const t = setTimeout(() => nav("/dashboard"), 4000);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-6">
      <img src={theme.hero} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className={`absolute inset-0 bg-gradient-to-br ${theme.gradient} opacity-95`} />

      <div className="absolute inset-0 pointer-events-none">
        {[...Array(28)].map((_, i) => (
          <motion.div key={`confetti-${i}`}
            initial={{ opacity: 0, y: -50, x: Math.random() * 1200 - 200, rotate: 0 }}
            animate={{ opacity: [0, 1, 0], y: [0, 700], rotate: 360 }}
            transition={{ delay: i * 0.08, duration: 3.5, repeat: Infinity, repeatDelay: 0.5 }}
            className={`absolute w-2 h-3 ${i % 3 === 0 ? "bg-amber-300" : i % 3 === 1 ? "bg-white" : "bg-emerald-200"}`} />
        ))}
      </div>

      <motion.div initial={{ scale: 0.85, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.7, ease: "easeOut" }}
        className="relative z-10 text-center text-white max-w-2xl">
        <motion.div initial={{ rotate: -20, scale: 0.5 }} animate={{ rotate: 0, scale: 1 }} transition={{ delay: 0.2, type: "spring" }}
          className="inline-flex items-center justify-center mb-8">
          <GTFLogo size={112} />
        </motion.div>
        <h1 className="hero-title text-5xl md:text-7xl font-bold">{t("welcome.title")}</h1>
        <p className="mt-6 text-2xl md:text-3xl font-light">{t("welcome.hello")} <b className="font-semibold">{user?.full_name}</b></p>
        <p className="mt-3 text-lg text-white/80">{t("welcome.joined_as")} <b className="text-amber-200">{theme.name}</b>. {t("welcome.ready")}</p>

        <button onClick={() => nav("/dashboard")} className="mt-10 inline-flex items-center gap-2 bg-white text-gray-900 hover:bg-gray-100 px-8 py-4 rounded-full font-semibold shadow-2xl">
          {t("welcome.go_dashboard")} <ArrowRight className="h-5 w-5" />
        </button>
      </motion.div>
    </div>
  );
}
